import { useMemo } from 'react'

import { useSingleCallResult, useSingleContractMultipleData } from '../state/multicall/hooks'
import { useDistributorContract } from './useContract'

/**
 *
 * @param {Contract | null}contract
 * @return {farms[]}
 */
export function useEmberFarms(contract: ReturnType<typeof useDistributorContract>) {

  const numberOfPools = useSingleCallResult(contract, 'poolLength', undefined, {
    blocksPerFetch: 100,
  })
  const args = useMemo(() => {
    const { result, loading } = numberOfPools
    if (loading) {
      return
    }
    return [...Array(Number(result)).keys()].map((pid) => [String(pid)])
  }, [numberOfPools])
  const poolInfo = useSingleContractMultipleData(
    args ? contract : null,
    'poolInfo',
    args ? args : []
  )
  // const pairAddresses = useMemo(() => {
  // return poolInfo.map((data) => {
  //   const { result, loading } = data
  //   if (loading) return
  //   if (result) {
  //     return result['lpToken'] as string
  //   }
  //   return
  // })
  // }, [poolInfo])

  return useMemo(() => {
    if (poolInfo && args) {
      return poolInfo.map((data, i) => {
        const { result, loading } = data

        if (loading) return 
        if (result) {
          // const { result:Token1Result, loading: Token1Loading } = token1Result[i]
          // const { result: Token0Result, loading: Token0Loading } = token0Result[i]
          //   if (Token0Loading || Token1Loading) return
          //   if (Token1Result && Token0Result){
          //   const [token0, token1] = (Token0Result[0] as Token).sortsBefore(Token1Result[0] as Token)
          //           ? [Token0Result[0], Token1Result[0]]
          //           : [Token1Result[0], Token0Result[0]]
          return {
            id: args[i][0] as string,
            lpToken: result[0] as string,
            // token0: token0 as Token,
            // token1: token1 as Token,
            allocPoint: parseInt(result[1].toString()),
            lastRewardBlock: parseInt(result[2].toString()),
            accEmberPerShare: parseInt(result[3].toString()),
            depositFeeBP: result[4] as number,
            harvestInterval: parseInt(result[5].toString()),
            totalLp: parseInt(result[6].toString()),
          } // }
        }
        return 
      })
    }
    return 
  }, [args, poolInfo])
}
/**
 * @return {ReturnType}
 */
export function useFarms() {
  return useEmberFarms(useDistributorContract())
}
